import React from "react";
import PersonasSlider from "components/persona-slider/persona-slider";
import "./home.css";

function Home() {
  return (
    <div className="home-page">
      <PersonasSlider />
    </div>
  );
}

export default Home;
